/** "12 Aug 2026" — matches the quiet, editorial tone of the notes pages. */
export function formatNoteDate(value: Date | string | null): string {
  if (!value) return "";
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "UTC",
  }).format(date);
}

/** "AUG 26" — used by the home page notes teaser. */
export function formatNoteMonthYear(value: Date | string | null): string {
  if (!value) return "";
  const date = typeof value === "string" ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) return "";
  const month = new Intl.DateTimeFormat("en-GB", {
    month: "short",
    timeZone: "UTC",
  })
    .format(date)
    .toUpperCase();
  const year = new Intl.DateTimeFormat("en-GB", {
    year: "2-digit",
    timeZone: "UTC",
  }).format(date);
  return `${month} ${year}`;
}
